import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getInsurers() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Insurance/Insurers?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPartners() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Insurance/Partners?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getClaimsStatus() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Insurance/Status/Claims?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getConfiguredNotes() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Insurance/Tasks/Claims?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getInsuranceQuote(QuoteID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Insurance/Quotes/${QuoteID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveClaim(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v4.0/Insurance/Claims?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveQuote(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v4.0/Insurance/Claims/Quotes?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  savePartnerQuote(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          '/v4.0/Insurance/Claims/Partner/Quotes?code=' +
          this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getClaims(statusID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          '/v4.0/Insurance/Claims/Status/' +
          statusID +
          '?code=' +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getClaim(claimID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          '/v4.0/Insurance/Claims/' +
          claimID +
          '?code=' +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPossibleAssignees() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          '/v4.0/Insurance/Insurers/Employees?code=' +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendMessage(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v4.0/Insurance/Messages?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendMessageToRaw(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v4.0/Insurance/Partner/Messages?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getShortenedURL(claimID) {
    var urlToShorten =
      window.location.protocol +
      '//' +
      window.location.host +
      '/client-claim/' +
      claimID;
    //var urlToShorten = "https://hibtigerportal.azurewebsites.net/client-claim/" + claimID;
    return this.http
      .get(
        'https://tny.im/yourls-api.php?action=shorturl&format=simple&url=' +
          urlToShorten,
      )
      .pipe(
        map((res: any) => {
          return res.text();
        }),
        catchError((res: any) => {
          return throwError(urlToShorten);
        }),
      );
  }

  getClaimQuotesForPartners(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Quotes/Parters/${PartnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getQuoteMessages(PartnerID, BikeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Partners/${PartnerID}/Claims/Messages/${BikeID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getQuoteMessagesPartner(PartnerID, BikeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Partners/${PartnerID}/Claims/Messages/${BikeID}?code=${this.env.key}&Partner=${PartnerID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getClaimQuotesFromPartners(PartnerID, BikeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Claims/Partners/${PartnerID}/Quotes/${BikeID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //=================================================================================================================================
  //CODE CLEAN UP -> NOTES
  //=================================================================================================================================

  saveNotes(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v4.0/Insurance/Claims/Notes?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getNotes(ClaimID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Claims/${ClaimID}/Notes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //=================================================================================================================================
  //TASKS
  //=================================================================================================================================

  getInsuranceQuoteTasks() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/v4.0/Insurance/Quotes/Tasks?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //=================================================================================================================================
  //CLAIM MESSAGES
  //=================================================================================================================================

  getInsuranceQuoteMessageStatus(PartnerID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/v4.0/Insurance/Claims/Partners/${PartnerID}/Messages?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //=================================================================================================================================
  //=================================================================================================================================
  //=================================================================================================================================
  //=================================================================================================================================
}
